var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePng = function SvgFilePng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E98300",
    d: "M15 0H4.125A1.12 1.12 0 0 0 3 1.12v21.755A1.12 1.12 0 0 0 4.12 24h15.755A1.123 1.123 0 0 0 21 22.88V6h-5.25a.75.75 0 0 1-.75-.75z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E98300",
    d: "M21 5.714V6h-5.25a.75.75 0 0 1-.75-.75V0h.286a1.13 1.13 0 0 1 .797.328l4.589 4.594a1.12 1.12 0 0 1 .328.792M3 14h18v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8EF",
    d: "M6.203 18.552h.39q.648 0 .648-.564t-.648-.564h-.39zm0 2.448H5.027v-4.524h1.872q.762 0 1.164.396.408.396.408 1.116t-.408 1.116q-.402.396-1.164.396h-.696zM9.093 21v-4.524h1.176l2.172 2.766v-2.766h1.17V21h-1.17l-2.172-2.766V21zM16.844 18.468h2.334q0 .36-.03.654t-.12.546a2.2 2.2 0 0 1-.342.63q-.216.27-.51.456-.288.18-.636.276a2.7 2.7 0 0 1-.732.096q-.528 0-.966-.174a2.2 2.2 0 0 1-.744-.486 2.3 2.3 0 0 1-.486-.756 2.7 2.7 0 0 1-.174-.978q0-.528.168-.966.174-.444.486-.756a2.2 2.2 0 0 1 .762-.486q.444-.174.99-.174.708 0 1.242.306t.846.948l-1.116.462q-.156-.372-.408-.534a1 1 0 0 0-.564-.162 1.11 1.11 0 0 0-.852.384q-.15.18-.24.438a1.9 1.9 0 0 0-.084.576q0 .288.072.534.078.246.228.426t.372.282q.222.096.516.096.174 0 .336-.036a1 1 0 0 0 .288-.126.7.7 0 0 0 .216-.228.9.9 0 0 0 .114-.336h-.966z"
  }))));
};
export default SvgFilePng;